import styled from 'styled-components';

export const StyledRobotDocking = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .robot-docking__icon {
    width: 24px;
    height: 24px;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  .robot-docking__label {
    ${(props): string => props.theme.fontStyles.caption.news}
    color: ${(props): string => props.theme.colors.darkGrey};
    width: auto;
    word-break: break-word;
    white-space: normal;
  }
`;
